var map = {
	"./404.svg": "sEM+",
	"./add.svg": "58n+",
	"./arrow-down.svg": "Peom",
	"./arrow-up.svg": "P3Ow",
	"./attention.svg": "K+Yn",
	"./bag.svg": "7EYT",
	"./bug.svg": "SVqS",
	"./bug1.svg": "wsc3",
	"./bug12.svg": "HyTe",
	"./bug15.svg": "q5uj",
	"./calendar.svg": "bc+5",
	"./chart.svg": "RjYk",
	"./checkbox-indeterminate-fill.svg": "w1GH",
	"./checked.svg": "l9Re",
	"./circleFinish.svg": "GJnQ",
	"./circleFinishInverse.svg": "Ckgy",
	"./clipboard.svg": "KO/S",
	"./completed.svg": "DVx+",
	"./component.svg": "s2cW",
	"./confirm.svg": "ltAG",
	"./dashboard.svg": "BCGP",
	"./date.svg": "Ve8B",
	"./decline.svg": "GkXH",
	"./delete.svg": "Imjp",
	"./deleteBack2.svg": "9D6w",
	"./dictionary.svg": "YRIb",
	"./documentation.svg": "zUKd",
	"./documents.svg": "GAL0",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./errorCircleBlack.svg": "AQ/u",
	"./errorTriangleBlack.svg": "cJBd",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./eye.svg": "4wdf",
	"./filePermit.svg": "SuHx",
	"./filter.svg": "ObMl",
	"./form.svg": "sTIr",
	"./group.svg": "hjGX",
	"./guide.svg": "z74U",
	"./helicopter-cargo.svg": "Zqio",
	"./helicopter.svg": "NvW2",
	"./helicopterRedCross.svg": "HTGm",
	"./hide-sidebar-horiz.svg": "GVsh",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./map.svg": "maBF",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./new.svg": "1DKM",
	"./new1.svg": "xFv8",
	"./package.svg": "860h",
	"./package2.svg": "6vBj",
	"./packageGen.svg": "Zrh2",
	"./password.svg": "QjmH",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./personCircle.svg": "4qzU",
	"./play.svg": "ufmG",
	"./plus.svg": "f+Cd",
	"./plus2.svg": "mFPN",
	"./qq.svg": "R2jY",
	"./refresh.svg": "SLu3",
	"./report.svg": "2nwU",
	"./save.svg": "ttre",
	"./scan-qr.svg": "hSKa",
	"./security3.svg": "XXrg",
	"./settings.svg": "rPJQ",
	"./settings_2.svg": "nZ3p",
	"./shoppingCard.svg": "dNDk",
	"./show-sidebar-horiz.svg": "Ce8o",
	"./star.svg": "60zo",
	"./tab.svg": "Jysk",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./threeDotsVertical.svg": "XPYq",
	"./trash.svg": "9CsS",
	"./ungroup.svg": "Wr2D",
	"./user.svg": "VdD3",
	"./userCircle.svg": "w+5K",
	"./userSecurity.svg": "S5GR",
	"./wechat.svg": "pYJ+",
	"./workflowDesign.svg": "2tVe",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 25